import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DownloadReport from '../../../../../components/ui/DownloadReport/DownloadReport';
import { getBlobUrl } from '../../../../../../../helpers/getBlobUrl';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import AvailableDocumentationModal from '../../../../../../../components/AvailableDocumentationModal/AvailableDocumentationModal';
import request from '../../../../../../../helpers/request';

const HouseDownloadReports = ({ awailableReports }) => {
  const [reports, setReports] = useState([]);

  const params = useParams();

  const { visible, showModal, hideModal } = useChangeModalVisible();

  const handleChange = (value) => {
    setReports(value);
  };

  const handleCancel = () => {
    setReports([]);
    hideModal();
  };

  const handleOk = () => {
    reports.forEach(async (item) => {
      const report = awailableReports.find(
        (awailableReport) => awailableReport.id === item
      );

      if (report) {
        const res = await request.get(
          report.url,
          { houseId: params.pageId },
          `При загрузке отчета "${report.name}" произошла ошибка`
        );

        if (res) {
          const url = getBlobUrl(res);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${report.name}.${report.extension}`);
          document.body.appendChild(link);
          link.click();
        }
      }
    });

    handleCancel();
  };

  return (
    <>
      <DownloadReport onClick={showModal} />
      <AvailableDocumentationModal
        visible={visible}
        okBtnText="Получить отчеты"
        modalTitle="Отчеты"
        onCancel={handleCancel}
        onOk={handleOk}
        selectTitle="Выберите отчеты"
        selectPlaceholder="Выберите один или несколько отчетов из списка"
        selectedItems={reports}
        onSelectChange={handleChange}
        items={awailableReports}
      />
    </>
  );
};

export default HouseDownloadReports;
